<div *ngIf="!isCompleted">
<div class="text-center">
  <a  [routerLink]="['/']" class="me-2 btn btn-primary"><i class="fa fa-list"></i>Cancel</a>
</div>

  <div class="row">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 text-center" *ngIf="!isCompleted">
      <h3>Data Delete Request</h3>
      <p>Enter Verification Code.</p>
      </div>
      <div class="col-sm-3"></div>
  </div>
  <form [formGroup] = "myFormVerification" (ngSubmit)="on_submitVerify()" class="form" enctype="multipart/form-data">



    <div class="form-group row mt-2" [ngClass]="{error:f.verificationCode.errors && f.verificationCode.touched}" >
      <div class="col-sm-3"></div>
        <label for="verificationCode" class='control-label col-sm-2' >Verification Code</label>
        <div class=" col-sm-3">
              <input type="text" id="verificationCode" formControlName="verificationCode" class="form-control" >
        </div>
        <div class="col-sm-4"></div>
        <div *ngIf="f.verificationCode.errors && f.verificationCode.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
        <ul><li>Invalid Verification Code</li></ul>
        </div>
      </div>

  <div class="text-center">
    <button [disabled]="isVerifying" type="submit" class="btn btn-primary mt-3 text-center">
        <span *ngIf="isVerifying" class="spinner-border spinner-border-sm me-1"></span>
        Submit
    </button>
  </div>

  </form>
</div>
<div *ngIf="isCompleted">
  <div class="alert alert-info text-center"> {{yieldMessage}}</div>
  <div class="text-center">
    <a  [routerLink]="['/']" class="me-2 btn btn-primary"><i class="fa fa-list"></i>OK</a>
  </div>

</div>
